export default function SettingsBilling() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-8">Billing</h1>
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
        <p className="text-gray-500">Billing and subscription management coming soon</p>
      </div>
    </div>
  );
}
